/**
 * Internal / report-fixture / staging-toy product titles must not appear as
 * “what you already buy”. Keep in sync with
 * express_app/services/growthEngine/isInternalOrFixtureTitle.js
 *
 * Examples:
 *   [TFR-NON-TFR-SPEND-AUG-2026-FIXTURE] Chips
 *   [GP-STOCK-JULY-2026-FIXTURE]
 *   1 Vic Test
 */
export const INTERNAL_OR_FIXTURE_TITLE_RE = /TFR-|FIXTURE/i

/** Staging toys like “1 Vic Test” — not a real kitchen line. */
export const TEST_OR_TOY_PRODUCT_TITLE_RE = /\bvic\s+test\b|(^|\s)test(\s|$)/i

export function isInternalOrFixtureTitle(value) {
  const title = String(value || '')
  return (
    INTERNAL_OR_FIXTURE_TITLE_RE.test(title) ||
    TEST_OR_TOY_PRODUCT_TITLE_RE.test(title)
  )
}

export function omitInternalOrFixtureSuggestedItems(items) {
  return (Array.isArray(items) ? items : []).filter(
    item => !isInternalOrFixtureTitle(item?.title),
  )
}

/**
 * Last-line Progress display scrub when fixture / toy titles leaked into copy.
 * Prefer Express personalisation filters; this only cleans residual display.
 *
 * @param {string|null|undefined} text
 * @returns {string}
 */
export function scrubInternalOrFixtureCopy(text) {
  const raw = String(text || '')
  if (!raw) return ''
  if (!INTERNAL_OR_FIXTURE_TITLE_RE.test(raw) && !/\bvic\s+test\b/i.test(raw)) {
    return raw
  }
  return raw
    .replace(/\[[^\]]*FIXTURE[^\]]*\]\s*/gi, '')
    .replace(/\bTFR-[A-Z0-9-]+\b/gi, '')
    .replace(/\b\d+\s+Vic Test\b/gi, 'a product you buy')
    .replace(/\bVic Test\b/gi, 'a product you buy')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+([,.])/g, '$1')
    .trim()
}
